module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('semantic-kanban', {
    attrs: {
      "tasks": _vm.tasks,
      "members": _vm.members,
      "options": _vm.options
    },
    on: {
      "updateTask": _vm.updateTask,
      "deleteTask": _vm.deleteTask,
      "addTag": _vm.addTag,
      "deleteTag": _vm.deleteTag,
      "updateMember": _vm.updateMember
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f25833a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 250
// module chunks = 1